import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 pb-52 pt-6"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl pb-20" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_4 = { class: "w-full px-2" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_9 = { class: "pi pi-check mr-2" }
const _hoisted_10 = {
  key: 0,
  class: "w-full"
}
const _hoisted_11 = { class: "flex flex-col items-center text-center rounded-lg shadow-lg mt-4 bg-gray-200" }
const _hoisted_12 = { class: "flex flex-wrap py-2 mb-4 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5" }, " DESCARGAR MI CREDENCIAL ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "text-gray-800 mb-4 text-2xl text-center pt-2 pb-5" }, " Por favor ingresá el DNI con el que te registraste para descargar tu credencial ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Field, {
                  name: "mailDni",
                  modelValue: _ctx.formData.mailDni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mailDni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Mail o DNI",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "mailDni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buscarAcreditado && _ctx.buscarAcreditado(...args))),
                class: "mt-2 px-4 py-2 bg-transparent border-blue-950 hover:bg-black text-blue-950 font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[4] || (_cache[4] = _createTextVNode("CONTINUAR "))
              ], 8, _hoisted_7)
            ]),
            (_ctx.isFormularioVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "mb-4 text-xl text-center pb-1 mt-4 text-black" }, " Hacé click en el siguiente botón para descargar tu entrada ", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.descargarArchivo && _ctx.descargarArchivo(...args))),
                        class: "mt-2 px-4 py-2 bg-black border-black hover:bg-white text-white hover:text-black border rounded"
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "pi pi-qrcode mr-2" }, null, -1),
                        _createTextVNode("DESCARGAR MI ENTRADA ")
                      ])),
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelarAcreditacion && _ctx.cancelarAcreditacion(...args))),
                        type: "button",
                        class: "mt-2 px-4 py-2 bg-black border-black hover:bg-white text-white hover:text-black border rounded"
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "pi pi-check mr-2" }, null, -1),
                        _createTextVNode("TERMINAR ")
                      ]))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-sm pt-6" }, [
              _createTextVNode("• Si todavía no estas registrado podes acreditarte haciendo "),
              _createElementVNode("a", {
                class: "font-semibold",
                href: "/agrievolution/"
              }, "click aquí")
            ], -1))
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}